// src/components/pcr/common/TextareaField.tsx
import React, { useRef } from 'react';
import { useAutoResizeTextarea } from '../../../hooks/useAutoResizeTextarea';
import { useForm } from '../../../contexts/FormContext';

interface TextareaFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  minHeight?: string;
}

const TextareaField: React.FC<TextareaFieldProps> = ({
  id,
  label,
  value,
  onChange,
  placeholder = '',
  minHeight = '24px'
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const { isReadOnly } = useForm();
  useAutoResizeTextarea(textareaRef as React.RefObject<HTMLTextAreaElement>);

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm">
      <div className="flex justify-between items-center mb-1">
        <label htmlFor={id} className="block text-sm font-medium text-gray-700">
          {label}
        </label>
      </div>
      <textarea
        ref={textareaRef}
        id={id}
        className={`mt-1 block w-full rounded-md border -2 border-gray-400 shadow-inner focus:border-indigo-500 focus:ring-indigo-500 overflow-hidden ${isReadOnly ? 'bg-gray-100' : ''}`}
        style={{ 
          minHeight, 
          lineHeight: '1.5', 
          paddingTop: 'calc(0.5rem - 1px)',  // Adjust for vertical centering
          verticalAlign: 'middle'
        }}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        readOnly={isReadOnly}
        disabled={isReadOnly}
      />
    </div>
  );
};

export default TextareaField;